<script setup lang="ts">
import { storeToRefs } from "pinia";
import { Filters } from "~/core/models/filters";
import { PATH_PARAMETERS_FIRMWARES } from "~/modules/firmware/constants";
import { FirmwareStatus } from "~/modules/firmware/models/FirmwareStatus.enum";
import { useOrganizationStore } from "~/modules/organization/stores/useOrganizationStore";

const { currentOrganization } = storeToRefs(useOrganizationStore());

const firmwareListRef = ref();
</script>

<template>
  <page-component>
    <firmware-list
      ref="firmwareListRef"
      :organization-code="currentOrganization?.code"
      :path-context="PATH_PARAMETERS_FIRMWARES"
      :default-filters="
        // MVP: tempoprary default filter on status=ACTIVATED for organization firmwares
        new Map<Filters, any>([[Filters.STATUS, FirmwareStatus.ACTIVATED]])
      "
      use-query-parameters-for-pagination
    />
  </page-component>
</template>
